
import { mapActions } from 'vuex';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: 'AppBrandNoticeSummary',
  props: {
    firstNotice: {
      type: Object,
      required: true
    },
    isNoticeSummaryLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    noticeContent() {
      const title = this.sanitizeText(this.firstNotice.title);
      const message = this.sanitizeText(this.firstNotice.message);
      return `[${title}] ${message}`;
    }
  },
  methods: {
    ...mapActions('dialog', ['openBrandNoticesDialog']),
    sanitizeText(text) {
      const html = marked.parse(text ?? '', { breaks: true });
      return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] }).trim();
    }
  }
};
